import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container q-pa-md q-px-lg" }
const _hoisted_2 = { class: "row q-col-gutter-lg" }
const _hoisted_3 = { class: "col-12 col-md-4" }
const _hoisted_4 = {
  class: "column items-center q-mt-md",
  style: {"gap":"16px"}
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "col-12 col-sm-6 col-md-3 col-lg" }
const _hoisted_7 = { class: "flex column q-gutter-y-sm" }
const _hoisted_8 = {
  href: "/blog/",
  target: "_blank",
  rel: "opener"
}
const _hoisted_9 = { class: "col-12 col-sm-6 col-md-3 col-lg" }
const _hoisted_10 = { class: "flex column q-gutter-y-sm" }
const _hoisted_11 = { class: "col-12 col-sm-6 col-md-3 col-lg" }
const _hoisted_12 = { class: "flex column q-gutter-y-sm" }
const _hoisted_13 = { class: "row q-col-gutter-sm items-center justify-between" }
const _hoisted_14 = { class: "col-12 col-md-auto q-mb-sm-md" }
const _hoisted_15 = { class: "text-caption text-grey-8 q-mb-xs text-center" }
const _hoisted_16 = { class: "col-12 col-md-auto" }
const _hoisted_17 = { class: "row q-gutter-sm flex-center" }

import SocialMediaLogos from 'components/SocialMediaLogos.vue'

// Footer link component for consistent styling

export default /*@__PURE__*/_defineComponent({
  __name: 'FooterBar',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_separator = _resolveComponent("q-separator")!

  return (_openBlock(), _createElementBlock("footer", {
    class: "c-footer bg-white q-footer--bordered",
    style: _normalizeStyle({
      'padding-bottom': `calc(env(safe-area-inset-bottom) + 1.5rem)`,
      'margin-bottom': _ctx.$q.screen.lt.sm ? '60px' : undefined
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, { to: {name: 'home'} }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: require('assets/logos/campertrader_logo_final_ocean_600.png'),
                  height: "40px",
                  width: "auto",
                  alt: "Camper Trader Logo"
                }, null, 8, _hoisted_5)
              ]),
              _: 1
            }),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-body2 text-grey-8 text-center" }, " Dein spezialisierter Marktplatz für Wohnmobile, Campervans, Mini Camper und Camping-Zubehör. Kaufe oder verkaufe kostenlos neue & gebrauchte Camper, finde Second-Hand-Artikel im Flohmarkt und regionale Dienstleister in deiner Nähe. ", -1))
          ]),
          _createVNode(SocialMediaLogos)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "text-subtitle1 text-weight-bold q-mb-md" }, "Camper Trader", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_router_link, { to: {name: 'home'} }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "chevron_right",
                  size: "xs",
                  class: "q-mr-xs"
                }),
                _cache[1] || (_cache[1] = _createElementVNode("span", null, "Startseite", -1))
              ]),
              _: 1
            }),
            _createElementVNode("a", _hoisted_8, [
              _createVNode(_component_q_icon, {
                name: "chevron_right",
                size: "xs",
                class: "q-mr-xs"
              }),
              _cache[2] || (_cache[2] = _createElementVNode("span", null, "Blog", -1))
            ]),
            _createVNode(_component_router_link, { to: {name: 'dealer-landing'} }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "chevron_right",
                  size: "xs",
                  class: "q-mr-xs"
                }),
                _cache[3] || (_cache[3] = _createElementVNode("span", null, "Händler werden", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: {name: 'partner'} }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "chevron_right",
                  size: "xs",
                  class: "q-mr-xs"
                }),
                _cache[4] || (_cache[4] = _createElementVNode("span", null, "Unsere Partner", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: {name: 'about-us'} }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "chevron_right",
                  size: "xs",
                  class: "q-mr-xs"
                }),
                _cache[5] || (_cache[5] = _createElementVNode("span", null, "Über uns", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: {name: 'pricing'} }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "chevron_right",
                  size: "xs",
                  class: "q-mr-xs"
                }),
                _cache[6] || (_cache[6] = _createElementVNode("span", null, "Preise", -1))
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "text-subtitle1 text-weight-bold q-mb-md" }, "Hilfe", -1)),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, { to: {name: 'faq-help'} }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "chevron_right",
                  size: "xs",
                  class: "q-mr-xs"
                }),
                _cache[8] || (_cache[8] = _createElementVNode("span", null, "FAQ & Hilfe", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: {name: 'privacy'} }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "chevron_right",
                  size: "xs",
                  class: "q-mr-xs"
                }),
                _cache[9] || (_cache[9] = _createElementVNode("span", null, "Datenschutz", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: {name: 'imprint'} }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "chevron_right",
                  size: "xs",
                  class: "q-mr-xs"
                }),
                _cache[10] || (_cache[10] = _createElementVNode("span", null, "Impressum", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: {name: 'contact'} }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "chevron_right",
                  size: "xs",
                  class: "q-mr-xs"
                }),
                _cache[11] || (_cache[11] = _createElementVNode("span", null, "Kontakt", -1))
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[18] || (_cache[18] = _createElementVNode("h3", { class: "text-subtitle1 text-weight-bold q-mb-md" }, "Fahrzeuge", -1)),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_router_link, { to: {name: 'wohnmobil-landing-page'} }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "chevron_right",
                  size: "xs",
                  class: "q-mr-xs"
                }),
                _cache[13] || (_cache[13] = _createElementVNode("span", null, "Wohnmobil kaufen", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: {name: 'campervan-landing-page'} }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "chevron_right",
                  size: "xs",
                  class: "q-mr-xs"
                }),
                _cache[14] || (_cache[14] = _createElementVNode("span", null, "Campervan kaufen", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: {name: 'mini-camper-landing-page'} }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "chevron_right",
                  size: "xs",
                  class: "q-mr-xs"
                }),
                _cache[15] || (_cache[15] = _createElementVNode("span", null, "Mini Camper kaufen", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: {name: 'search'} }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "chevron_right",
                  size: "xs",
                  class: "q-mr-xs"
                }),
                _cache[16] || (_cache[16] = _createElementVNode("span", null, "Erweiterte Suche", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: {name: 'createAdvert'} }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "chevron_right",
                  size: "xs",
                  class: "q-mr-xs"
                }),
                _cache[17] || (_cache[17] = _createElementVNode("span", null, "Camper verkaufen", -1))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode(_component_q_separator, { class: "q-my-lg" }),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("p", _hoisted_15, " © " + _toDisplayString(new Date().getFullYear()) + " Camper Trader. Alle Rechte vorbehalten. ", 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_router_link, {
              to: {name: 'privacy'},
              class: "text-caption"
            }, {
              default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                _createTextVNode("Datenschutz", -1)
              ]))]),
              _: 1
            }),
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "text-grey-5" }, "|", -1)),
            _createVNode(_component_router_link, {
              to: {name: 'imprint'},
              class: "text-caption"
            }, {
              default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                _createTextVNode("Impressum", -1)
              ]))]),
              _: 1
            }),
            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "text-grey-5" }, "|", -1)),
            _createVNode(_component_router_link, {
              to: {name: 'privacy'},
              class: "text-caption"
            }, {
              default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                _createTextVNode("Cookie-Einstellungen", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ], 4))
}
}

})